/**
 * `@for` track helpers.
 *
 * Angular reports NG0955 when a track expression yields the same key for more
 * than one item. A missing field is the usual cause — `undefined`, `null` and
 * `''` all print as `key ""` in the warning, so a table tracked by an id the
 * API never sends produces one duplicate pair per row.
 *
 * Both helpers prefix the key. Without the prefix a row whose numeric id is `2`
 * would collide with a keyless row sitting at index `2`.
 */

/** Stable key for a row that carries its own identity; falls back to position. */
export function trackId(index: number, item: any): string {
  const id = item?.id ?? item?._id ?? item?.orderID ?? item?.orderId;
  return id != null && id !== '' ? `k:${id}` : `i:${index}`;
}

/** Same contract for rows keyed by a natural field (symbol, ticker, currency, date). */
export function trackKey(index: number, key: unknown): string {
  return key != null && key !== '' ? `k:${key}` : `i:${index}`;
}
